import React from 'react';
import { motion } from 'framer-motion';
import './ActionButton.css';
import Icon from '../home/Icon';

const buttonVariants = {
  initial: { scale: 1 },
  hover: { scale: 1.02, cursor: 'pointer' },
  click: { scale: 0.97, transition: { duration: 0.01 } }
};

// title / ariaLabel: tooltip and accessible name — needed for icon-only buttons (no label).
function ActionButton({ icon, label, onClick, type, disabled, style, buttonType = 'button', title, ariaLabel }) {
  const colorClass = type === 1 ? 'negative' : type === 2 ? 'positive' : type === 3 ? 'accent' : type === 4 ? 'warning' : '';

  return (
    <motion.button
      type={buttonType}
      className={`actionBtn ${colorClass} ${label ? '' : 'iconOnly'}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
      title={title}
      aria-label={ariaLabel}
      variants={buttonVariants}
      initial="initial"
      whileHover="hover"
      whileTap="click"
    >
      {icon && <Icon className="actionBtnIcon" icon={icon} />}
      {label && <span>{label}</span>}
    </motion.button>
  );
}

export default ActionButton;
